










































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import BackendDynamicFields from '../../settings/components/BackendDynamicFields.vue';
import {
    formatList,
    getIdsFromList,
    hasElements,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import { Company, SuscriptionsList, Template, UsersEmails, Suscription, Vehicle, AvailableVehiclesList, RadioOptions, RadioOption, UserCompaniesReports } from '../../core/models';
import { BackendDynamicField } from '../../alarms/api/types';
import { ReportsServices } from '../api/ReportsServices';
import { getBackendFieldsFormatted, updateBackendFieldsWithPatchData } from '../../../features/core/utils/logic_backend_fields';


@Component({
    components: {
        Loading,
        Button,
        SectionTitle,
        BackendDynamicFields
    }
})
export default class ModalReportSettings extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    // @Prop({default(){return []}}) templatesList: Array<Template>;
    @Prop({default: null}) suscriptionData: SuscriptionsList;
  
    thereAreEmptyDynamicFields: boolean = false;
    fetchingDynamicFields: boolean = false;
    dynamicFields: BackendDynamicField = {} as BackendDynamicField;
    pendingSettings: boolean = false;


    fetchDynamicFields(){
        this.fetchingDynamicFields = true;
        ReportsServices.getDynamicFields(
            this.suscriptionData.template.template_id
        ).then((res) => {
             this.dynamicFields = getBackendFieldsFormatted(res);
             //add patch data
             if(this.suscriptionData && this.suscriptionData.settings){
                let reportSettings = this.suscriptionData.settings;
                let hasElements = Object.keys(reportSettings).length > 0;
                if(hasElements){
                    this.dynamicFields = updateBackendFieldsWithPatchData(reportSettings, this.dynamicFields);
                }
             }

        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudieron obtener los campos');
        }).finally(() => {
            this.fetchingDynamicFields = false;
        });
    }

    updateDynamicFieldsAreEmpty(value: boolean){
        this.thereAreEmptyDynamicFields = value;
    }
    
    get isPatch(){
        
        return false
    }

    get dynamicFieldsComponent(): HTMLFormElement {
        return this.$refs.componentBackendDynamicFields as HTMLFormElement;
    }



    submitConfig(){
        let data = this.dynamicFieldsComponent.getCurrentFields();
        this.saveConfiguration(data);
    }


    saveConfiguration(config){
        this.pendingSettings = true;
        this.pendingLoadingDialog('Guardando configuración...');
        let templateId = this.suscriptionData.template.template_id;
        ReportsServices.saveReportSettings(
            templateId,
            config,
        ).then((res) => {
            this.handleSuccessAction(res, 'Configuración guardada con éxito');
            if(res && res['new_settings']){
                this.updateSettingsInReportList(
                    templateId,
                    res['new_settings']
                );
            }
        }).catch((err) => {
            this.handleErrorAction(err, 'No se pudo guardar la configuración');
        }).finally(() => {
            this.pendingSettings = false;
        });
    }

    @Emit()
    updateSettingsInReportList(
        template_id: SuscriptionsList["template"]["template_id"],
        new_settings: SuscriptionsList["settings"]
    ){}


    formatCompanies(value){
        return formatList(value, 'name');
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response, alternative_msg){
        this.$_successLoadingDialog({
            response: response,
            alternative_msg: alternative_msg,
            timeout: 2000
        });
        this.closeModal();
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error && error.response && error.response.data || {},
            alternative_msg: alternative_msg
        });
    }


    loadPatchData() {
        if(this.isPatch){
           
        }
    }


    get formIsValid() {
        return this.thereAreEmptyDynamicFields ? false : true;
    }

    resetFields(){
       
    }

    @Emit()
    closeModal() {
        this.resetFields();
    }

    mounted() {
        this.$nextTick(() => {
            this.loadPatchData();
        });
    }
}
